<div class="chatroom">
  <div class="welcome" *ngIf="showWelcomeMessage && chatroomId === null">
    <h3 class="welcome-title">{{ "WELCOME_TO_FANS" | translate }}</h3>
    <p class="welcome-message">{{ "WELCOME_MESSAGE" | translate }}</p>
  </div>
  <div class="message-box" *ngIf="chatroomId !== null && !error" #messageBox>
    <app-message
      *ngFor="let message of messages"
      [message]="message"
      [messageSide]="message.sentBy?.id !== currentUserId ? 'left' : 'right'">
    </app-message>
  </div>
  <form class="input-wrapper" [formGroup]="chatForm" *ngIf="chatroomId !== null && !error">
    <textarea
      formControlName="chatInput"
      (input)="onChangeInput()"
      (keydown.enter)="onPressEnter($event)"
      autosize
      [minRows]="1"
      [maxRows]="5">
    </textarea>
    <div class="button-wrapper" (click)="onSendMessage()">
      <img src="assets/img/arrow-right.svg" alt="" />
    </div>
  </form>
  <p class="error" *ngIf="error">{{error}}</p>
</div>
